import { useMemo } from 'react'
import { AdminAPI, getFragment, GraphQL, SharedAPI } from '@guestgoodie/graphql'
import usePaginatedQuery from '@/hooks/usePaginatedQuery'

export type QueryVariables = {
  filter: GraphQL.QueryPromotionsFilter
  sort: GraphQL.QueryPromotionsSort
}

export default function usePaginatedPromotions(variables: QueryVariables) {
  const variablesWithGoodie = useMemo(
    () => ({
      ...variables,
      withGoodie: true
    }),
    [variables]
  )

  const { items: fragmentItems, ...rest } = usePaginatedQuery(
    AdminAPI.promotion.QUERY,
    variablesWithGoodie,
    {
      document: AdminAPI.promotion.CHANGED,
      typename: 'PROMOTION',
      variables: {
        withGoodie: true
      }
    }
  )

  const items = useMemo(() => {
    return fragmentItems?.map(item =>
      getFragment(SharedAPI.promotion.PROMOTION_FRAGMENT, item)
    )
  }, [fragmentItems])

  return {
    items,
    ...rest
  }
}
